var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("speaker-navbar", {
        staticClass: "mb-1",
        attrs: {
          filter: _vm.filter,
          "fav-key": "content_code",
          "fav-mode": _vm.favoriteMode,
        },
        on: {
          search: function ($event) {
            return _vm.onSearchChanged($event)
          },
          "delete-search": function ($event) {
            return _vm.onSearchChanged($event)
          },
          "toggle-favorites": function ($event) {
            return _vm.toggleFavorites($event)
          },
        },
      }),
      _vm._v(" "),
      _vm.numSpeakers > 0
        ? _c("div", [
            _c("small", { staticClass: "text-muted me-1" }, [
              _vm._v(
                _vm._s(_vm.numFavorites) +
                  " Favoriten / " +
                  _vm._s(_vm.numSpeakers) +
                  " Treffer"
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-wrap justify-content-between align-items-stretch mt-1",
              },
              _vm._l(_vm.speakers, function (speaker) {
                return _c("speaker-card", {
                  key: speaker.id,
                  attrs: { speaker: speaker },
                  on: { "favorite-changed": _vm.getFavorites },
                })
              }),
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "py-3 text-center" }, [
              _c("button", { attrs: { disabled: _vm.page == 1 } }, [
                _c("i", {
                  staticClass: "fas fa-chevron-left",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.previousPage()
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "mx-3" }, [
                _vm._v(_vm._s(_vm.page) + " / " + _vm._s(_vm.numPages)),
              ]),
              _vm._v(" "),
              _c("button", { attrs: { disabled: _vm.page == _vm.numPages } }, [
                _c("i", {
                  staticClass: "fas fa-chevron-right",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.nextPage()
                    },
                  },
                }),
              ]),
            ]),
          ])
        : _c("div", [
            _c("div", { staticClass: "text-center mt-5" }, [
              _vm._v("-- keine Treffer --"),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }